require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./prix-et-distinctions-2-3-6.json") })
        }
      }, "path---prix-et-distinctions-2-3-6");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---prix-et-distinctions-2-3-6!./.cache/json/prix-et-distinctions-2-3-6.json
// module id = 532
// module chunks = 231608221292675